import { post } from '../axios'

// 新增Or更新页面或模块
export function category_addOrUpdate_post(map, option) {
  return post(
    `${process.env.VUE_APP_CATEGORY}/category/addOrUpdate`,
    map,
    option
  ).then(response => response)
}

// 新增Or更新页面或模块
export function category_delete_post(map, option) {
  return post(
    `${process.env.VUE_APP_CATEGORY}/category/delete`,
    map,
    option
  ).then(response => response)
}

// 页面模块列表
export function category_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_CATEGORY}/category/list`,
    map,
    option
  ).then(response => response)
}
